import { mdiDelete } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import IconButton from './IconButton'

const ButtonDelete = (props) => {
    const {
        showLabel = false,
        title = null,
        onClick = null,
        disabled = false,
        size = 1,
        overrides = null,
    } = props
    const label = showLabel ? <span>{title ?? 'Delete Items'}</span> : null

    return (
        <IconButton
            title={title}
            data-testid={props['data-testid'] ?? 'IconButton__DeleteToggle'}
            onClick={onClick}
            showLabel={showLabel}
            css={overrides}
            disabled={disabled}
        >
            <Icon path={mdiDelete} size={size} />
            {label}
        </IconButton>
    )
}

export default memo(ButtonDelete)
